module.exports = __webpack_public_path__ + "88db48c81286b65e8f459145bb746975.jpg";